import React from "react";
import WarningPanelv2 from "../../lib/warning_panel/warning_panel_v2";

const SuccessPage = () => {
  return (
    <div>
      Your campaign has been sent to the podcasts you selected. They will now have 5 days to respond
      to your request.
      <br />
      <br />
      <WarningPanelv2>
        <div className="redcircle-form-label">NEXT STEPS</div>
        As podcasts accept your campaign, be sure to <b>Download Podcast Info</b> for important
        information that you will need for your campaign.
        <br />
        <br />
        Depending on your campaign, this could include information like mailing addresses so you can
        ship free product, unique show promo codes so you can add them in your system, and which
        redemption promo codes were matched to which hosts.
        <br />
        <br />
        <b>Reminder:</b> The ‘Download Podcast Info’ list will update every time a new podcast
        accepts, so continue to check back and re-export as needed so you don’t miss any show
        information.
      </WarningPanelv2>
    </div>
  );
};

export default SuccessPage;
